import { useLocalization } from '@lib/localization';
import { useLocation } from 'react-router-dom';
import { validate as uuidValidate } from 'uuid';
import NavbarBreadcrumbs from './Breadcrumbs';

export interface BreadcrumbItem {
  label: string;
  link?: string;
}

export interface DynamicBreadcrumbsProps {
  breadcrumbItems?: BreadcrumbItem[];
}

const pathKeys = [
  'Folders', 'Projects', 'Inspections', 'Checklists', 'Poi', 'Steps', 'Users', 'Server Config', 'Settings'
];

const DynamicBreadcrumbs: React.FC<DynamicBreadcrumbsProps> = ({ breadcrumbItems }) => {
  const location = useLocation();
  const { t } = useLocalization();

  const dynamicBreadcrumbItems: BreadcrumbItem[] = [
    { label: t('Common_Home'), link: '/' },
    ...location.pathname.split('/').filter((x) => x).map((value, index) => {
      const label = index == 0 || (!location.pathname.startsWith('/folders') && !uuidValidate(value))
        ? value.split('-').map(labelPart => labelPart.charAt(0).toUpperCase() + labelPart.slice(1)).join(' ')
        : decodeURIComponent(value);

      const link = `/${location.pathname.split('/').slice(1, index + 2).join('/')}`;

      const matchedLocalizedLabel = pathKeys.find(pathKey => pathKey == label);
      const localizedLabel = matchedLocalizedLabel
        ? t(`Common_${matchedLocalizedLabel.replace(/\s+/g, '').trim()}`)
        : label;

      return { label: localizedLabel, link };
    }),
  ];

  const itemsToRender = breadcrumbItems || dynamicBreadcrumbItems;

  return <NavbarBreadcrumbs items={itemsToRender} />;
};

export default DynamicBreadcrumbs;
